import { Component, OnInit } from "@angular/core";
import { getSolarAccountEs } from "@edp-store/selectors/ES/solar-account-es.selectors";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { select, Store } from "@ngrx/store";
import { take } from "rxjs/operators";

@Component({
    selector: "edp-contract-list-welcome",
    templateUrl: "./edp-contract-list-welcome.component.html",
    styleUrls: ["./edp-contract-list-welcome.component.scss"],
})
export class EdpContractListWelcomeComponent implements OnInit {
    public userName: string;

    constructor(private storeEs: Store<IAppEsState>) {}

    public ngOnInit(): void {
        this.storeEs.pipe(select(getSolarAccountEs), take(1)).subscribe(account => {
            if (account) {
                this.userName = account.username.toLocaleLowerCase();
            }
        });
    }
}
